export default {
  /**
   * @param {String} token
   * @param {Array<Number>} farmerIds
   * @param {String} date
   * @param {Object} params
   * @param {Object} headers
   * @param {null} cancelToken
   * @returns {{headers: {}, method: string, url: string}}
   */
  stats(token, farmerIds, date, params = {}, headers = {}, cancelToken = null) {
    return {
      url: `/shipment/stats/${date}`,
      method: 'GET',
      headers: {
        Authorization: token,
        ...headers,
      },
      params: {
        farmer_ids: farmerIds,
        states: ['printed', 'saved'],
        ...params,
      },
      ...(cancelToken !== null ? { cancelToken } : {}),
    }
  },
  /**
   * @param {String} token
   * @param {Array<Number>} farmerIds
   * @param {Object} params
   * @param {Object} headers
   * @param {null} cancelToken
   * @returns {{headers: {}, method: string, url: string}}
   */
  calendar(token, farmerIds, params = {}, headers = {}, cancelToken = null) {
    return {
      url: '/shipment/stats/calendar',
      method: 'GET',
      headers: {
        Authorization: token,
        ...headers,
      },
      params: {
        ...params,
      },
      ...(cancelToken !== null ? { cancelToken } : {}),
    }
  },

}
